import axios from 'axios';
import { parseMaterials } from './utils';
import {
  parsePrograms,
  parseProfessions,
  parseCompetences,
  parseVacancies,
  parseEmployers,
  parseContractorPartners,
} from './utils/parsePrograms';
import camelize from '@/tools/camelize';
import { SmartPoints, ERROR_MESSAGE } from './const';
import {
  AxiosInstance,
  TestResults,
  TestResult,
  RecommendedPrograms,
  Vector,
  VectorData,
  Materials,
  Blocks,
  Block,
  DataPayload,
  Cards,
  ISmartService,
} from './types';

// в дальнейшем, вынести в отдельный сервис intalentService

const intalentApi = axios.create({
  baseURL: SmartPoints.INTALENT_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

const getProfessions = async (vector: VectorData): Promise<Cards> => {
  try {
    const result = camelize(vector);
    const { data } = await intalentApi.post(SmartPoints.GET_PROFESSIONS, {
      ...result,
    });
    return parseMaterials(data.recomendations);
  } catch (error) {
    throw new Error(ERROR_MESSAGE);
  }
};

const getMaterials = async (vector: VectorData): Promise<Materials> => {
  try {
    const result = camelize(vector);
    const { data } = await intalentApi.post(SmartPoints.GET_MATERIALS, {
      ...result,
    });
    const materials = data.length ? data[0] : {};
    return {
      interviews: parseMaterials(materials.interviews),
      articles: parseMaterials(materials.articles),
      videos: parseMaterials(materials.videos),
    };
  } catch (error) {
    throw new Error(ERROR_MESSAGE);
  }
};

const intalentService = {
  getMaterials,
  getProfessions,
};

// конец сервиса

const getTestResultsData = (api: AxiosInstance) => ({
  getTestResults: async (id: string): Promise<TestResults> => {
    try {
      const { data } = await api.get(SmartPoints.GET_TEST_RESULTS, {
        params: { site_user_kid_id: id },
      });
      const result = data ? data.data : [];
      return result.map((item: TestResult) => {
        const { created, ...vector } = item;
        return vector;
      });
    } catch (error) {
      throw new Error(ERROR_MESSAGE);
    }
  },
});

const getRecProgramsData = (api: AxiosInstance) => ({
  getRecPrograms: async (vector: Vector): Promise<RecommendedPrograms> => {
    vector.age = undefined;
    try {
      const { data } = await api.get(SmartPoints.GET_REC_PROGRAMS, {
        params: { ...vector },
      });
      return {
        competences: parseCompetences(data.data.competences || []),
        professions: parseProfessions(data.data.professions || []),
        programs: parsePrograms(data.data.programs || []),
        vacancies: parseVacancies(data.data.vacancies || []),
        employer_partners: parseEmployers(data.data.employer_partners || []),
        contractor_partners: parseContractorPartners(
          data.data.contractor_partners || []
        ),
      };
    } catch (error) {
      throw new Error(ERROR_MESSAGE);
    }
  },
});

// это вообще на утилиту больше похоже

const setDataToBlocks = (payload: DataPayload): Blocks => {
  const { age, municipalityId, blocks, testResult } = payload;
  const { id, site_user_kid_id, ...vector } = testResult;
  return blocks.map((item: Block) => {
    return item.method === 'getRecPrograms'
      ? {
          ...item,
          data: {
            version: 'v2',
            ...camelize(vector),
            municipality_id: municipalityId,
            offset: 0,
            limit: 4,
          },
        }
      : {
          ...item,
          data: vector,
        };
  });
};

const smartService = (api: AxiosInstance): ISmartService => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getTestResultsData(api),
    ...getRecProgramsData(api),
    ...intalentService,
    setDataToBlocks,
  };
};

export default smartService;



// WEBPACK FOOTER //
// ./src/services/smart/smartService.ts